import React from 'react';
import sanitizeHtml from 'sanitize-html';
import PropTypes from 'prop-types';

const SanitizedHTML = ({ dirty, ...rest }) => {
  return (
    <div
      style={{ width: '100%' }}
      {...rest}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(dirty) }}
    />
  );
};

SanitizedHTML.defaultProps = {
  dirty: '',
};

SanitizedHTML.propTypes = {
  dirty: PropTypes.string.isRequired,
};

export default SanitizedHTML;
